// 产品分类树状态
import { getPortalProductCategories } from '@/api/portal'
import { getEnabledPortalCategoryTree } from '@/components/modules/products/utils/productHelpers'

let categoryFetchSeq = 0
let inflightCategoryFetch = null

export default {
  namespaced: true,
  state: {
    items: [],
    itemsLocale: '',
    loading: false,
    loaded: false
  },
  getters: {
    enabledItems(state) {
      return getEnabledPortalCategoryTree(state.items)
    }
  },
  mutations: {
    SET_ITEMS(state, { items, locale }) {
      state.items = items || []
      state.itemsLocale = locale || ''
      state.loaded = true
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    RESET(state) {
      state.items = []
      state.itemsLocale = ''
      state.loaded = false
    }
  },
  actions: {
    async reloadCategories({ commit, dispatch }) {
      categoryFetchSeq += 1
      inflightCategoryFetch = null
      commit('RESET')
      await dispatch('fetchCategories', { force: true })
    },
    async fetchCategories({ commit, state, rootState }, options) {
      const { force = false } = options ?? {}
      const locale = rootState.locale.current
      if (!locale) return

      if (!force && state.loaded && state.itemsLocale === locale) return

      if (force) {
        categoryFetchSeq += 1
        inflightCategoryFetch = null
      }

      if (inflightCategoryFetch?.locale === locale && !force) {
        return inflightCategoryFetch.promise
      }

      const seq = ++categoryFetchSeq
      commit('SET_LOADING', true)

      // promise
      const promise = (async () => {
        try {
          const data = await getPortalProductCategories(locale, { reload: force })
          if (seq !== categoryFetchSeq) return
          commit('SET_ITEMS', { items: data || [], locale })
        } catch (error) {
          if (seq !== categoryFetchSeq) return
          commit('SET_ITEMS', { items: [], locale })
          throw error
        } finally {
          if (seq === categoryFetchSeq) {
            commit('SET_LOADING', false)
          }
        }
      })()

      inflightCategoryFetch = { locale, promise }
      try {
        await promise
      } finally {
        if (inflightCategoryFetch?.promise === promise) {
          inflightCategoryFetch = null
        }
      }
    }
  }
}
